import { headerCommonProps } from "./commonHeaderProps";
import currency from "barcelo-shared/currency";

const header = {
  props: {
    dynamicClass: ".c-header.dynamicLoading",
    className: "header",
    cHeaderSelector: ".c-header",
    classNameActive: "mod--active",
    classLanguageDialog: "language-dialog-container-JS",
    $containerUnderlay: null,
    $containerLanguageDialog: null,
    idHelpButton: "helpButton",
    mybmenusPopOverSelector: ".js-item-myBarcelo-popover",
    mybmenusSelector: ".js-item-myBarcelo",
    blockedCurrency: "",
    userLevelSelector: ".js-level-user-logo",
    levels: {
      STANDAR: "1",
      INTENSE: "2",
      UNIQUE: "3",
    },
    levelsClasses: {
      STANDAR: "c-myb-logo-standard",
      INTENSE: "c-myb-logo-intense",
      UNIQUE: "c-myb-logo-unique",
    },
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-header.css", this.props.dynamicClass);

    currency.init();
    bcl.u.callWhenLoadUser(bcl.u.initMybUserComponents);

    const $component = document.getElementsByClassName(this.props.className);
    if (!$component || !$component[0]) {
      return;
    }

    headerCommonProps.$container = $component[0];

    this.initContainer();

    this.showHelpButton();
    bcl.u.resize(this.resize);
  },

  initContainer: function () {
    const $cHeader = headerCommonProps.$container.querySelector(this.props.cHeaderSelector);
    if ($cHeader) {
      this.props.blockedCurrency = $cHeader.dataset.blockedcurrency;
      if (this.props.blockedCurrency && this.props.blockedCurrency != currency.props.currency.market && currency.props.marketRelativeRatesMap) {
        const rate = bcl.s.currency.props.marketRelativeRatesMap?.[this.props.blockedCurrency].rate;
        bcl.s.currency.changeCurrency(this.props.blockedCurrency, rate, null, true);
      }
    }
  },
  resize: function () {
    bcl.c.header?.megaMenu?.resize();
    bcl.c.header?.sticky?.resize();
  },
  showHelpButton: function () {
    const button = document.getElementById(this.props.idHelpButton);
    if (button && (button.dataset.button == window.location.pathname || button.dataset.button == window.location.href)) {
      button.remove();
    }
  },
  changeLogoByLevel: function () {
    const userLogo = document.querySelector(this.props.userLevelSelector);
    const user = bcl.u.getContextHubUser();
    if (userLogo && user && user["myb-level"]) {
      const levelClass = this.props.levelsClasses[bcl.u.getKeyByValue(this.props.levels, user["myb-level"])];
      const barceloMenuV2 = document.querySelector(".js-myb-menu-v2");
      if (levelClass) {
        userLogo.classList.add(levelClass);
        if (barceloMenuV2 && barceloMenuV2.classList.contains("mod--menu-v2")) {
          if (user["myb"] == "1" || bcl.u.getKeyByValue(this.props.levels, user["myb-level"]) == "STANDAR") {
            // Essential
            barceloMenuV2.classList.add("mod--essential-bg");
          } else if (user["myb"] == "2" || bcl.u.getKeyByValue(this.props.levels, user["myb-level"]) == "INTENSE") {
            // Intese - Special
            barceloMenuV2.classList.add("mod--special-bg");
          } else if (user["myb"] == "3" || bcl.u.getKeyByValue(this.props.levels, user["myb-level"]) == "UNIQUE") {
            // Unique
            barceloMenuV2.classList.add("mod--unique-bg");
          }
        }
      }
    }
  },
  showModalMyBarcelo: function (user) {
    bcl.profile.login = user && user.federationId ? "true" : "false";
    const headersComponent = document.querySelectorAll(bcl.c.header.props.cHeaderSelector);
    headersComponent.forEach((element) => {
      const mybmenus = element.querySelectorAll(this.props.mybmenusSelector);
      const mybmenusPopOver = element.querySelectorAll(this.props.mybmenusPopOverSelector);
      const login = bcl.profile.login;
      if (login === "true" && mybmenus[0] != null && mybmenusPopOver[1] != null) {
        mybmenusPopOver[1].remove();
        mybmenus[0].remove();
        if (mybmenus[1]) {
          mybmenus[1].classList.remove("hidden");
        }
        element.querySelector("ul.loggin-status-JS").classList.add("user-logged");
        this.changeLogoByLevel();
      } else if (login === "false" && mybmenus[1] != null && mybmenusPopOver[0] != null) {
        mybmenusPopOver[0].remove();
        mybmenus[1].remove();
        if (mybmenus[0]) {
          mybmenus[0].classList.remove("hidden");
        }
        element.querySelector("ul.loggin-status-JS").classList.add("noUser-logged");
      }
    });
  },
};

export default header;
